import {CORE, gateway} from '../../api';

export function getTipoDescontoCliente() {
  return gateway.get(`${CORE}/tipos-desconto`);
}
